const USER_KEY = 'userTrackingId';
let inMemoryUserKey: string | null = null;

// Generates a unique ID using crypto.randomUUID if available
function generateUniqueId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Check if localStorage is available
function isLocalStorageAvailable(): boolean {
  try {
    const testKey = '__test__';
    localStorage.setItem(testKey, testKey);
    localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

function setLocalStorageItem(key: string, value: string): boolean {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (error) {
    return false;
  }
}

function getLocalStorageItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

// Cookie utility functions
function setCookie(name: string, value: string, days: number): void {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let c of ca) {
    c = c.trimStart()
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

export function getOrCreateUserId(): string {
  // If we already have the session ID in memory, use it.
  if (inMemoryUserKey) {
    return inMemoryUserKey;
  }
  
  let UserKey: string | null = null;
  
  // Try localStorage first if available.
  if (isLocalStorageAvailable()) {
    UserKey = getLocalStorageItem(USER_KEY);
    if (UserKey) {
      inMemoryUserKey = UserKey;
      return UserKey;
    }
  }
  
  // Fallback to cookies.
  UserKey = getCookie(USER_KEY);
  if (UserKey) {
    inMemoryUserKey = UserKey;
    return UserKey;
  }
  
  // If no session ID was found, generate a new one.
  UserKey = generateUniqueId();
  
  // Try to store in localStorage if possible.
  if (isLocalStorageAvailable() && setLocalStorageItem(USER_KEY, UserKey)) {
  } else {
    // Otherwise, store in a cookie (expires in 30 days).
    setCookie(USER_KEY, UserKey, 30);
  }
  
  // Also store in memory as a last resort.
  inMemoryUserKey = UserKey;
  return UserKey;
}